import React from 'react';
import useGlobal from '../../store';
import ArchiveItemCard from '../Gift/ArchiveItemCard';

const Archive = (props) => {
   
    const [archive] = useGlobal(
        state => state.activeGiftlist.archive
    );

    const archiveItems = archive.map(gift => <ArchiveItemCard {...gift}></ArchiveItemCard>);

    return (
        <>
            <div className="kt-portlet">
                <div className="kt-portlet__head kt-portlet__head--lg">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-heading kt-heading--lg">Archived Gifts from Previous Years</h3>
                    </div>
                </div>
   
                <div className="kt-portlet__body">
                    {archiveItems}
                </div>

            </div>
        </>
    );
}
export default Archive;